import { Exclude, Expose, Type } from 'class-transformer';
import { ChannelType, PlatformAccountDTO } from './platform-account.dto';
import { UserMemberDTO } from './user-member.dto';
import { WorkspaceNotificationDTO } from './workspace-notification.dto';

@Exclude()
export class WorkspaceDTO {
  @Expose()
  id: number;

  @Expose()
  name: string;

  @Expose()
  pic: string;

  @Expose()
  @Type(() => PlatformAccountDTO)
  platformAccounts: PlatformAccountDTO[];

  @Expose()
  @Type(() => UserMemberDTO)
  teamMembers: UserMemberDTO[];

  @Expose()
  isOwner: boolean;

  @Expose()
  isActive: boolean;

  @Expose()
  workspaceNotification: WorkspaceNotificationDTO;

  get channelCount() {
    return {
      [ChannelType.INSTAGRAM]:
        this.platformAccounts &&
        this.platformAccounts.filter((account) => account.isInstagram).length,
      [ChannelType.PINTEREST]:
        this.platformAccounts &&
        this.platformAccounts.filter((account) => account.isPinterest).length,
      [ChannelType.TIKTOK]:
        this.platformAccounts && this.platformAccounts.filter((account) => account.isTiktok).length,
      [ChannelType.FACEBOOK]:
        this.platformAccounts &&
        this.platformAccounts.filter((account) => account.isFacebook).length,
      [ChannelType.TWITTER]:
        this.platformAccounts && this.platformAccounts.filter((account) => account.isTwitter).length
    };
  }
}
